"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AppBar_1 = __importDefault(require("@mui/material/AppBar"));
var Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
var Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var styles_1 = require("@mui/material/styles");
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var config_1 = require("../../config");
var flavor_config_1 = require("../../flavor-config");
var Logo_1 = __importDefault(require("../Logo"));
var ToolbarButton_1 = __importDefault(require("./ToolbarButton"));
var UserPanel_1 = __importDefault(require("./UserPanel"));
var LocaleSelector_1 = __importDefault(require("../Intl/LocaleSelector"));
var AppSelector_1 = __importDefault(require("../AppSelector"));
var logo = (0, flavor_config_1.requireWFFlavorAsset)('images/logo_small.png');
var defaultApps = (0, config_1.getConfig)().APP_SELECTOR_APPS;
var useStyles = (0, makeStyles_1.default)(function (theme) { return ({
    appBar: {
        backgroundColor: theme.palette.secondary.dark,
    },
    appName: {
        lineHeight: 1,
        whiteSpace: 'nowrap',
    },
    link: {
        display: 'flex',
        'align-items': 'center',
        textDecoration: 'none',
    },
    toolbar: {
        paddingLeft: 0,
        paddingRight: 0,
        minHeight: 56,
    },
    collapsedLogo: {
        paddingLeft: 16,
    },
}); });
var MainAppBar = function (_a) {
    var _b;
    var appName = _a.appName, controls = _a.controls, actions = _a.actions, userMenuActions = _a.userMenuActions, _c = _a.apps, apps = _c === void 0 ? defaultApps : _c, onExpand = _a.onExpand;
    var classes = useStyles();
    var theme = (0, styles_1.useTheme)();
    return (React.createElement(AppBar_1.default, { color: "secondary", classes: { root: classes.appBar } },
        React.createElement(Toolbar_1.default, { classes: { root: classes.toolbar } },
            onExpand && (React.createElement(ToolbarButton_1.default, { color: "secondary", onClick: onExpand },
                React.createElement(Menu_1.default, null))),
            React.createElement(react_router_dom_1.Link, { to: "/", className: classes.link },
                React.createElement(Logo_1.default, { src: logo, className: onExpand ? undefined : classes.collapsedLogo }),
                React.createElement(Typography_1.default, { color: "secondary", variant: "h5", className: classes.appName }, appName)),
            React.createElement(Stack_1.default, { direction: "row", spacing: 1, marginLeft: "auto", marginRight: theme.spacing((_b = theme.pagePadding) !== null && _b !== void 0 ? _b : 1.5), sx: { alignItems: 'center' } },
                controls,
                React.createElement(LocaleSelector_1.default, null),
                apps && React.createElement(AppSelector_1.default, { apps: apps }),
                React.createElement(UserPanel_1.default, { actions: actions, userMenuActions: userMenuActions })))));
};
exports.default = MainAppBar;
